// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"90106248","455":"a17874f4"}[chunkId] + ".chunk.js";
};